import styled from 'styled-components';

export const StyledFourColumnsSpan = styled.div`
   display: flex;
   flex-direction: column;
   gap: 20px;
   grid-column: span 4;
   height: fit-content;

   &:empty {
      display: none;
   }
`;

StyledFourColumnsSpan.displayName = 'StyledFourColumnsSpan';

export const StyledTwoColumnsSpan = styled.div`
   grid-column: span 2;
`;

StyledTwoColumnsSpan.displayName = 'StyledTwoColumnsSpan';

export const StyledForm = styled.form`
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   column-gap: 36px;
   row-gap: 20px;
`;

StyledForm.displayName = 'StyledForm';
